module.exports = __webpack_public_path__ + "static/media/carta_51.c3dd5601.jpg";